/**
 * Site-wide announcement banner (FEA-30, docs/FRONTEND-PLAN.md section 4.3).
 *
 * Purely presentational and settings-agnostic on purpose: Layout supplies
 * the live public settings plus per-session dismissal (sessionStorage,
 * keyed by message so an edited announcement re-appears even if the old
 * text was dismissed); Admin's Settings tab reuses this exact component,
 * undismissable, as the live preview of an unsaved form - "the same
 * component as the real banner" per the plan, not a lookalike.
 */
import { cn, ui } from '../lib/ui';

const TONES = {
  info: 'bg-dcon-info-soft text-dcon-info',
  warning: 'bg-dcon-warning-soft text-dcon-warning',
};

export default function AnnouncementBanner({ enabled, message, tone = 'info', onDismiss }) {
  if (!enabled || !message) return null;
  const toneClass = tone === 'warning' ? TONES.warning : TONES.info;

  return (
    <div className={cn('py-2', toneClass)} role="status">
      <div className={cn(ui.container, 'flex items-center justify-between gap-3 text-body-s')}>
        <span>{message}</span>
        {onDismiss && (
          <button
            type="button"
            className="min-h-touch min-w-touch cursor-pointer rounded-dcon-sm border-0 bg-transparent px-1 text-title-s leading-none text-current"
            aria-label="Dismiss announcement"
            onClick={onDismiss}
          >
            &times;
          </button>
        )}
      </div>
    </div>
  );
}
